// extracted by mini-css-extract-plugin
module.exports = {"block2":"hover_block2__3kh0S","block1":"hover_block1__2aW5X"};